import React from 'react';
import {useSelector} from 'react-redux';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingState} from 'redux-stores/reduceApp';
import DuplicateRunSchemaButton from 'runs/run-schemas/DuplicateRunSchemaButton';
import SchemaSettingsExportDropdown from 'schemas/SchemaSettingsExportDropdown';
import {SCHEMA_TYPES} from 'schemas/spec/SchemaConfigConstants';

interface AssaySchemaToolbarProps {
  schemaId: string;
  schemaType: keyof typeof SCHEMA_TYPES;
  isSpecJsonFormat: boolean;
}

export default function AssaySchemaToolbar(props: AssaySchemaToolbarProps): JSX.Element {
  const sessionId = useSelector((state: BenchlingState) => state.ui.schemaConfig.sessionId);
  const hasUnsavedData = useSelector((state: BenchlingState) => state.ui.schemaConfig.hasUnsavedData);
  const inputFileConfigs = useSelector((state: BenchlingState) => state.ui.schemaConfig.inputFileConfigs);
  const outputFileConfigs = useSelector((state: BenchlingState) => state.ui.schemaConfig.outputFileConfigs);
  return (
    <>
      {props.schemaType === LegacyAssaySchemaType.ASSAY_RUN ? (
        <DuplicateRunSchemaButton
          className="u-mini-spacing-right"
          schemaId={props.schemaId}
          hasUnsavedData={hasUnsavedData}
          sessionId={sessionId}
          isSpecJsonFormat={props.isSpecJsonFormat}
          inputFileConfigs={inputFileConfigs}
          outputFileConfigs={outputFileConfigs}
        />
      ) : null}
      <SchemaSettingsExportDropdown
        schemaId={props.schemaId}
        schemaType={props.schemaType as ModelTypeConstants}
      />
    </>
  );
}
